export enum SalesChannel {
  RENT_FRIEND,
  RENT_DEALER_VC,
  RENT_PLUG,
  RENT_DEALER,
  RENT_API,
  RENT_PLACE,
}
export enum AdditionalServiceType {
  OTHER,
  WARRANTY,
  INSURANCE,
}
export enum ClientType {
  ALL,
  B2B,
  B2C,
}

export enum AdditionalCustomType {
  FLEX = 'FLEX',
  CASUAL = 'CASUAL',
  CUSTOM = 'CUSTOM',
  WITHOUT_CREDIT_REGISTRY = 'WITHOUT_CREDIT_REGISTRY',
}
